module.exports = __webpack_public_path__ + "static/media/kjetting.f83b7d49.mp3";